// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_AtributosLaudoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/atributos_laudo/{order_item_id}/{report_type}.
 *
 * Object-shaped dados containing the category attribute definitions and the
 * order item's currently saved values.
 */
import type { Orders_LaudoAttributeDefinitionRow } from './Orders_LaudoAttributeDefinitionRow'
import type { Orders_LaudoAttributeValueRow } from './Orders_LaudoAttributeValueRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_AtributosLaudoResponseDados {
definitions: Orders_LaudoAttributeDefinitionRow[]
values: Orders_LaudoAttributeValueRow[]
}

export type Orders_AtributosLaudoResponse = ApiResponse<Orders_AtributosLaudoResponseDados>;

registerResponseContract('Orders_AtributosLaudoResponse', {
  definitions: {
    type: 'array',
    required: true,
    items: {
      so_cra_id:            { type: 'number',  required: true },
      so_cra_category_id:   { type: 'number',  required: true },
      so_cra_attribute_id:  { type: 'number',  required: true },
      so_cra_required:      { type: 'number',  required: true },
      so_cra_display_order: { type: 'number',  required: true },
      so_cra_report_type:   { type: 'string',  required: true },
      so_cra_created_at:    { type: 'string',  required: true },
      so_ra_id:             { type: 'number',  required: true },
      so_ra_name:           { type: 'string',  required: true },
      so_ra_type:           { type: 'string',  required: true },
      so_ra_options: {
        type: 'array',
        required: false,
        items: {
          ID:   { type: 'string',  required: true },
          Name: { type: 'string',  required: true },
        },
      },
    },
  },
  values: {
    type: 'array',
    required: true,
    items: {
      so_rav_id:           { type: 'number',  required: true },
      so_rav_report_id:    { type: 'number',  required: true },
      so_rav_report_type:  { type: 'string',  required: true },
      so_rav_attribute_id: { type: 'number',  required: true },
      so_rav_value:        { type: 'string',  required: false },
      so_rav_created_at:   { type: 'string',  required: true },
      so_ra_name:          { type: 'string',  required: true },
      so_ra_type:          { type: 'string',  required: true },
    },
  },
})
